import { PointCloud } from "./PointCloud";
import { Util } from "./Util";
import { EARTH_RADIUS_KM } from "./constants";

export class Swath extends PointCloud {

  constructor(metadata){
    super();
    this.metadata = metadata;
  }

  toString(){
    return this.metadata.filename;
  }

  loadSwath({ts, lats, lngs, vals, alphaFunction,
    pointSize = 2.0,
    bbox = undefined,
    colormap,
    shader,
    swathHeight = 10.0
  }){

    if(bbox){
      [ts, lats, lngs, vals] = this.crop(ts, lats, lngs, vals, bbox);
    }

    let positions = new Float32Array(ts.length * 3);
    let colors = new Float32Array(ts.length * 3);
    let sizes = new Float32Array(ts.length);
    let alphas = new Float32Array(ts.length);

    for (let i = 0; i < ts.length; i++) {

      let coord = Util.polar2cartesian(lats[i], lngs[i], 100*((swathHeight / EARTH_RADIUS_KM) + 1));

      positions[i * 3 + 0] = coord[0];
      positions[i * 3 + 1] = coord[1];
      positions[i * 3 + 2] = coord[2];

      let color = Util.evaluate_cmap(vals[i], colormap, false);

      colors[i * 3 + 0] = color[0];
      colors[i * 3 + 1] = color[1];
      colors[i * 3 + 2] = color[2];

      sizes[i] = pointSize * window.devicePixelRatio;
      alphas[i] = alphaFunction(vals[i]);

    }

    this.ts = ts;
    this.lats = lats;
    this.lngs = lngs;
    this.vals = vals;
  
    this.load(positions, colors, sizes, alphas, shader);

    this.loaded = true;

  }

  crop(ts, lats, lngs, vals, bbox){
    let new_ts = [];
    let new_lat = [];
    let new_lng = [];
    let new_vals = [];
    for (let i = 0; i < ts.length; i++) {
      if(    bbox[1] < lats[i] && bbox[3] > lats[i]
          && bbox[0] < lngs[i] && bbox[2] > lngs[i]){
        new_ts.push(ts[i]);
        new_lat.push(lats[i]);
        new_lng.push(lngs[i]);
        new_vals.push(vals[i]);
      }
    }
    return [new_ts, new_lat, new_lng, new_vals];
  }

  fade(simTime, fadeTime, fadeDelay){

    if(!this.loaded) return;

    for (let i = 0; i < this.ts.length; i++) {

      let now = Util.ms2us(this.ts[i]);

      if (now > simTime) {
        this.alphas[i] = 0;
      } else if (now > simTime - fadeTime) {
        this.alphas[i] = Math.abs(now - simTime) / fadeTime;
      } else if (now < simTime - fadeDelay) {
        this.alphas[i] = 0;
      } else if (now < simTime - fadeDelay + fadeTime) {
        this.alphas[i] = Math.abs(now - simTime + fadeDelay) / fadeTime;
      } else {
        this.alphas[i] = 1;
      }

    }

    this.geometry.attributes.alpha.needsUpdate = true;

  }
  
}